import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { KnownCategories } from '../../viewmodels/AppViewModels';

const QUERY_BASE_KEY = 'handwrittenCardCategories';

export const useHandwrittenCardCategories = ({
	enabled = true,
	industry,
	withAll = false,
	withMyTemplates = false,
	impersonationContext,
}: {
	enabled?: boolean;
	industry: Api.Industry;
	withAll?: boolean;
	withMyTemplates?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			let categories = await userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `template/${encodeURIComponent(industry)}/cardCategories`,
					impersonationContext,
				}),
				'GET'
			);

			categories = categories.filter(c => c !== 'Archived' && c !== 'Uncategorized');
			if (withMyTemplates) {
				categories.unshift(KnownCategories.MyTemplates);
			}
			if (withAll) {
				categories.unshift(KnownCategories.All);
			}
			return categories;
		},
		queryKey: [QUERY_BASE_KEY, { industry }],
	});
};
